import { render } from "./VariablePicker.vue?vue&type=template&id=5ae98222&scoped=true"
import script from "./VariablePicker.vue?vue&type=script&lang=js"
export * from "./VariablePicker.vue?vue&type=script&lang=js"

import "./VariablePicker.vue?vue&type=style&index=0&id=5ae98222&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae98222"]])

export default __exports__